import { useBreakpoint } from "@povio/ui";
import { NextStep } from "nextstepjs";
import type { PropsWithChildren } from "react";
import { useState } from "react";

import { TourCompletedModal } from "@/components/onboarding/modals/TourCompletedModal";
import { TourCard } from "@/components/ui/tours/TourCard/TourCard";
import { demoTourConfig, demoTourMobileConfig } from "@/config/tour.config";

/**
 * NextStep wrapper that has access to DemoContext
 * This allows us to trigger context actions when the tour completes
 */
const NextStepWithDemoContext = ({ children }: PropsWithChildren) => {
  const isDesktop = useBreakpoint("md");
  const [isTourCompletedModalOpen, setIsTourCompletedModalOpen] = useState(false);

  // Load appropriate tour config based on screen size
  const tourConfig = isDesktop ? demoTourConfig : demoTourMobileConfig;

  const handleComplete = () => {
    // Show the tour completed modal instead of redirecting immediately
    setIsTourCompletedModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsTourCompletedModalOpen(false);
  };

  return (
    <>
      <NextStep
        steps={[tourConfig]}
        cardComponent={TourCard}
        shadowOpacity="0"
        cardTransition={{ duration: 0.001 }}
        onComplete={handleComplete}
      >
        {children}
      </NextStep>
      <TourCompletedModal
        isOpen={isTourCompletedModalOpen}
        onClose={handleCloseModal}
      />
    </>
  );
};

export default NextStepWithDemoContext;
